
import { defineComponent } from "vue";
import "./card.scss";

export default defineComponent({
  name: "adm-card-actions",
  inheritAttrs: false,
});
